module.exports = "/_next/static/images/b7fb08952cf53854bd275bfb2e382dc9-contract.png.webp";